import { post, get, postJson } from '../request';
import urls from './apilist';

//设置提现密码
function setPayPwd(params) {
  return post(urls.setPayPwd,params)
}

//修改提现密码
function updatePayPwd(params) {
  return post(urls.updatePayPwd, params)
}

//修改手机号
//oldMobileCode旧手机的验证码，newMobilePhone新手机号，newMobileCode新手机验证码
function updatePhone(params) {
  return post(urls.updatePhone, params)
}
const apis = {
  setPayPwd,
  updatePayPwd,
  updatePhone
};

export default apis;
